import { STAFF_FUNCTIONS, type TradeFunctionHolderDto } from '@bqcrm/shared';
import { Badge, Group, Table, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { api } from '../../api';
import { QueryState } from '../QueryState';

/** Kto pełni funkcje w branży (Ustawienia → Branże) — z osobami z zakresem „wszystkie branże”. */
export function TradeFunctionHolders({ code }: { code: string }) {
  const q = useQuery({ queryKey: ['trade-functions', code], queryFn: () => api<TradeFunctionHolderDto[]>(`/trades/${code}/functions`) });
  return (
    <QueryState isLoading={q.isLoading} error={q.error}>
      <Table.ScrollContainer minWidth={420}>
        <Table verticalSpacing={4}>
          <Table.Tbody>
            {q.data?.map((h) => {
              const active = h.users.filter((u) => u.active);
              return (
                <Table.Tr key={h.function}>
                  <Table.Td w={170}>
                    <Text size="sm">{STAFF_FUNCTIONS[h.function]}</Text>
                  </Table.Td>
                  <Table.Td>
                    {active.length === 0 ? (
                      <Badge color="orange" variant="light">
                        nikt — zadania będą nieobsadzone
                      </Badge>
                    ) : (
                      <Group gap={4}>
                        {active.map((u) => (
                          <Badge
                            key={u.id}
                            component={Link}
                            to={`/pracownicy/${u.id}`}
                            variant={u.allTrades ? 'outline' : 'light'}
                            color="gray"
                            tt="none"
                            title={u.allTrades ? 'Wszystkie branże — otwórz kartę pracownika' : 'Ta branża — otwórz kartę pracownika'}
                            style={{ cursor: 'pointer' }}
                          >
                            {u.fullName}
                            {u.allTrades ? ' · wszystkie' : ''}
                          </Badge>
                        ))}
                      </Group>
                    )}
                  </Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </QueryState>
  );
}
